import { render, staticRenderFns } from "./AddressFormStep.vue?vue&type=template&id=ea8957e8&"
import script from "./AddressFormStep.vue?vue&type=script&lang=js&"
export * from "./AddressFormStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports